import React from 'react';
import { PracticeSession } from '../../utils/activityHelpers';
import { formatDistanceToNow } from '../../utils/formatters';
import { CheckCircle2, XCircle, MinusCircle } from 'lucide-react';
interface ActivityTimelineProps {
  sessions: PracticeSession[];
  emptyMessage?: string;
}
export function ActivityTimeline({
  sessions,
  emptyMessage = 'Geen recente activiteit'
}: ActivityTimelineProps) {
  if (sessions.length === 0) {
    return <div className="text-center py-8 text-slate-500 italic text-sm" data-id="element-2233">
        {emptyMessage}
      </div>;
  }
  return <div className="space-y-4" data-id="element-2234">
      {sessions.map((session, i) => {
      let statusIcon = <MinusCircle className="w-5 h-5 text-amber-500" data-id="element-2235" />;
      let statusBg = 'bg-amber-50 border-amber-100';
      if (session.accuracy >= 80) {
        statusIcon = <CheckCircle2 className="w-5 h-5 text-emerald-500" data-id="element-2236" />;
        statusBg = 'bg-emerald-50 border-emerald-100';
      } else if (session.accuracy < 50) {
        statusIcon = <XCircle className="w-5 h-5 text-rose-500" data-id="element-2237" />;
        statusBg = 'bg-rose-50 border-rose-100';
      }
      return <div key={i} className="flex gap-4 relative" data-id="element-2238">
            {/* Timeline line */}
            {i !== sessions.length - 1 && <div className="absolute left-5 top-10 bottom-[-16px] w-0.5 bg-slate-200" data-id="element-2239" />}

            <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 flex-shrink-0 z-10 bg-white ${statusBg.split(' ')[1]}`} data-id="element-2240">
              <span className="text-lg" data-id="element-2241">{session.moduleIcon}</span>
            </div>

            <div className={`flex-1 p-3 rounded-xl border ${statusBg}`} data-id="element-2242">
              <div className="flex justify-between items-start mb-1" data-id="element-2243">
                <h4 className="font-bold text-slate-800" data-id="element-2244">
                  {session.moduleTitle}
                </h4>
                <span className="text-xs font-medium text-slate-500" data-id="element-2245">
                  {formatDistanceToNow(session.date)}
                </span>
              </div>
              <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-2246">
                <span data-id="element-2247">{session.questionCount} vragen</span>
                <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-2248" />
                <span className="flex items-center gap-1" data-id="element-2249">
                  {statusIcon} {session.accuracy}% goed
                </span>
              </div>
            </div>
          </div>;
    })}
    </div>;
}